import { useEffect, useRef, useState } from 'react';
import { TITLE_2 } from '@entities/leadCollector';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface FormHeaderProps {
  type: number;
  onChange: (headerTitle: string) => void;
  isCanEdit: boolean;
  value: string;
}

export const FormHeader = ({ type, value, onChange, isCanEdit }: FormHeaderProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [header, setHeader] = useState('');

  const handleChangeHeader = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const text = e.target.value.replace(/\n/g, ' ');
    onChange(text);
    setHeader(text);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  const handleDragStart = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    if (!textareaRef.current) return;

    textareaRef.current.style.height = 'auto';
    textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
  }, [header]);

  useEffect(() => {
    setHeader(value);
  }, [value]);

  return (
    <textarea
      {...stylex.props(styles.header, type === TITLE_2 && styles.headerTwo)}
      ref={textareaRef}
      value={header}
      onChange={handleChangeHeader}
      onKeyDown={handleKeyDown}
      rows={1}
      maxLength={type === TITLE_2 ? 95 : 78}
      placeholder="Введите название заголовка"
      draggable
      onDragStart={handleDragStart}
      disabled={isCanEdit}
    />
  );
};
